import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTransferNotifications } from '../contexts/TransferNotificationsContext';
import './TransferBadge.css';

const TransferBadge = () => {
  const [count, setCount] = useState(0);
  const [previousCount, setPreviousCount] = useState(0);
  const [animate, setAnimate] = useState(false);
  // Get the refresh timestamp from context
  const { refreshTimestamp } = useTransferNotifications();

  const fetchPendingCount = async () => {
    try {
      const response = await axios.get('/transfers/pending-count');
      
      // Store previous count for animation comparison
      setPreviousCount(count);
      
      // Update count with new value
      setCount(response.data.count);
      
      // Trigger animation if count changed
      if (response.data.count !== count) {
        setAnimate(true);
        setTimeout(() => setAnimate(false), 500);
      }
    } catch (error) {
      console.error('Error fetching pending transfer count:', error);
    }
  };

  useEffect(() => {
    // Fetch count whenever refreshTimestamp changes
    fetchPendingCount();
    
    // Set up polling interval
    const interval = setInterval(fetchPendingCount, 30000);
    
    // Check if API endpoint is accessible (just for debugging)
    axios.head('/transfers/pending-count')
      .then(response => {
        console.log('Transfer notification API check:', 
          response.status === 200 ? 'SUCCESS' : 'FAILED');
      })
      .catch(error => {
        console.error('Transfer notification API check FAILED:', error.message);
      });
    
    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, [refreshTimestamp]); // Add refreshTimestamp as a dependency

  // Don't render anything if count is 0
  if (count === 0) return null;

  return (
    <span 
      className={`transfer-badge ${animate ? 'badge-update' : ''}`}
      aria-label={`${count} pending transfers`}
    >
      {count}
    </span>
  );
};

export default TransferBadge;
